import { Component, OnInit } from "@angular/core";
import { NewAdminService } from "../services/new-admin.service";

@Component({
  selector: "cintas-add-new-admin",
  templateUrl: "./add-new-admin.component.html",
  styleUrls: ["./add-new-admin.component.scss"],
})
export class AddNewAdminComponent implements OnInit {
  constructor(private newAdminService: NewAdminService) {}

  ngOnInit() {}

  onSubmit(adminData: any): void {
    this.newAdminService.addAdmin(adminData.value).subscribe(
      (response) => {
        alert("Admin added successfully");
        adminData.reset();
      },
      (error) => {
        if (error.status === 422) {
          const validationErrors = error.error.errors;
          if (validationErrors.email) {
            alert(validationErrors.email);
          }
          if (validationErrors.password) {
            alert(validationErrors.password);
          }
        } else {
          console.error('Please Try Again! Error adding Admin', error);
          alert('Please Try Again! Error adding Admin' + error.message);
        }
      }
    )

  }
}
